import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { activeSnack } from './common';
import { del, get, put, post } from '../http';
import { covertToJSON } from '../../utils/stateToJson';

// --- API THUNKS START ---
export const createClub = createAsyncThunk(
  'club/create',
  async ({ state, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/club/admin/new`;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(activeSnack({ type: 'success', message: 'Club created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getAllClubs = createAsyncThunk(
  'club/list',
  async ({ page, search, dispatch, limit }) => {
    try {
      const response = await get(
        `/club/admin/all?page=${page && page}&search=${search || ''}&limit=${limit || 5}`
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getClubDetails = createAsyncThunk('club/single', async ({ clubId, dispatch }) => {
  try {
    const response = await get(`/club/admin/${clubId}`);
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
export const updateClubDetails = createAsyncThunk(
  'club/update',
  async ({ state, clubId, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/club/admin/${clubId}`;
      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        dispatch(activeSnack({ type: 'success', message: 'Club updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const deleteClub = createAsyncThunk(
  'club/delete',
  async ({ clubId, dispatch, handleCloseDeleteDialog }) => {
    try {
      const response = await del(`/club/admin/${clubId}/`);
      if (response) {
        handleCloseDeleteDialog();
        dispatch(activeSnack({ type: 'success', message: 'Club deleted Successfully' }));
        return response?._id;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const clubSlice = createSlice({
  name: 'club',
  initialState: {
    loading: false,
    error: {},
    // staff
    clubs: {},
    clubDetails: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [createClub.pending]: (state) => {
      state.loading = true;
    },
    [createClub.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.clubs;
      const newList = jsonState?.clubs;
      const modifiedList = {
        ...jsonState,
        clubs: Array.isArray(newList) ? [action.payload, ...newList] : [action.payload],
      };
      state.loading = false;
      state.clubs = modifiedList;
      state.error = {};
    },
    [createClub.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllClubs.pending]: (state) => {
      state.loading = true;
    },
    [getAllClubs.fulfilled]: (state, action) => {
      state.loading = false;
      state.clubs = action.payload;
      state.error = {};
    },
    [getAllClubs.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getClubDetails.pending]: (state) => {
      state.loading = true;
    },
    [getClubDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.clubDetails = action.payload;
      state.error = {};
    },
    [getClubDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [updateClubDetails.pending]: (state) => {
      state.loading = true;
    },
    [updateClubDetails.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.clubs;
      const modifiedList = {
        ...jsonState,
        clubs: jsonState.clubs?.map((i) => (i._id === action.payload._id ? action?.payload : i)),
      };

      state.loading = false;
      state.clubs = modifiedList;
      state.error = {};
    },
    [updateClubDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [deleteClub.pending]: (state) => {
      state.loading = true;
    },
    [deleteClub.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.clubs;
      const modifiedList = {
        ...jsonState,
        clubs: jsonState.clubs?.filter((member) => member._id !== action.payload),
      };
      state.loading = false;
      state.clubs = modifiedList;
      state.error = {};
    },
    [deleteClub.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = clubSlice.actions;

export default clubSlice.reducer;
